import React from 'react';
import { Link } from 'react-router-dom';
import { BrainCircuit } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-100 border-t border-slate-200">
      <div className="container mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-8 mb-4 md:mb-0">
            <div className="flex items-center space-x-2 text-xl font-bold text-slate-800">
              <BrainCircuit className="w-7 h-7 text-emerald-500" />
              <span>ThreadIt</span>
            </div>
            <div className="flex space-x-6 text-sm text-slate-500">
              <Link to="/privacy" className="hover:text-emerald-500 transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-emerald-500 transition-colors">Terms of Service</Link>
              <Link to="/impressum" className="hover:text-emerald-500 transition-colors">Impressum</Link>
            </div>
          </div>
          <div className="flex space-x-6 text-slate-500">
            <Link to="/#features" className="hover:text-emerald-500 transition-colors">Features</Link>
            <Link to="/pricing" className="hover:text-emerald-500 transition-colors">Pricing</Link>
            <Link to="/contact" className="hover:text-emerald-500 transition-colors">Contact</Link>
          </div>
        </div>
        <div className="mt-8 text-center text-slate-500 text-sm">
          <p>&copy; {new Date().getFullYear()} ThreadIt Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;